import React from "react";
import styled from "styled-components";
import { CFontIcon, H5 } from "@appcues/component-library";

import CoolTip from "components/Common/CoolTip";
import { getThemeFor } from "utils";

const ProductLabel = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px 8px;
  margin: 3px 10px;
  min-width: 135px;
  height: 24px;
  border: 2px solid ${getThemeFor("$smurfs-blood")};
  border-radius: 2px 12px;
  color: black;
  .svg-inline--fa {
    color: ${getThemeFor("$smurfs-blood")};
  }
`;

const EnterpriseLabel = () => {
  return (
    <CoolTip tip="Contact Support to upgrade and gain access">
      <ProductLabel>
        <CFontIcon className="fa fa-lock" alt="Locked" />
        <H5 bold>Enterprise</H5>
      </ProductLabel>
    </CoolTip>
  );
};

export default EnterpriseLabel;
